var snappervariantImageFilter = function() {
    function create_element_append_to_body(el, elId, display) {
        display || (display = "none");
        var g = document.createElement(el);
        g.id = elId, g.style = "display:" + display, document.body.appendChild(g)
    }

    function find_current_variant(section) {
        var variant_id, element = section || document;
        default_variant = 0 == default_variant ? Object.keys(product_variants)[0] : default_variant;
        var queries = {};
        if (document.location.search.substr(1).split("&").forEach((function(q) {
            var i = q.split("=");
            try {
                queries[i[0].toString()] = i[1].toString()
            } catch (err) {}
        })), isNaN(queries.variant)) {
            let selector = element.querySelector('form[action="/cart/add"] [name="id"]:checked') || element.querySelector('form[action="/cart/add"] [name="id"]') || element.querySelector('select[name="id"]') || element.querySelector('[name="id"]');
            variant_id = selector ? selector.value : default_variant
        } else variant_id = queries.variant ? queries.variant : element.querySelector("select option[value='" + default_variant + "']").parentNode.value;
        return variant_id || default_variant
    }

    function is_variant_in_url() {
        return document.location.search.indexOf("variant=") >= 0
    }

    function find_current_variant_from_url() {
        var variant_id, queries = {};
        return document.location.search.substr(1).split("&").forEach((function(q) {
            var i = q.split("=");
            try {
                queries[i[0].toString()] = i[1].toString()
            } catch (err) {}
        })), isNaN(queries.variant) ? variant_id = null : queries.variant && (variant_id = queries.variant), variant_id
    }

    function find_variant_images(variant_id) {
        var variant_images;
        if (variant_id || (variant_id = find_current_variant()), variants.hasOwnProperty(variant_id) ? variant_images = variants[variant_id] : (variant_id = find_current_variant_from_url(), variant_images = variants.hasOwnProperty(variant_id) ? variants[variant_id] : variants[default_variant]), (!variant_images || 0 == variant_images.length) && skip_showcase_image >= product_images.length) return product_images;
        if (!is_home && "no_action" != only_run_if_variant_in_url && !is_variant_in_url()) {
            function showcase_images() {
                return variants.g.length ? variants.g : variant_assigned_images
            }

            function skipped_and_showcase_images() {
                let images = variants.skipped.concat(variants.g);
                return images.length ? images : variant_assigned_images
            }
            if (selection_vid = 0, "showcase_only" == only_run_if_variant_in_url) return showcase_images();
            if ("showcase_and_variants" == only_run_if_variant_in_url) return variants.g.concat(variant_assigned_images);
            if ("featured_only" == only_run_if_variant_in_url) return [product_images[0]];
            if ("featured_and_showcase" == only_run_if_variant_in_url) return skip_showcase_image > 0 ? [product_images[0]].concat(variants.g) : showcase_images();
            if ("skipped_and_showcase" == only_run_if_variant_in_url) return skipped_and_showcase_images();
            if ("show_all" == only_run_if_variant_in_url) return product_images
        }
        return "at_start" == general_images_position ? variant_images = variants.g.concat(variant_images) : "at_end" == general_images_position && (variant_images = variant_images.concat(variants.g)), variant_images && 0 != variant_images.length ? variant_images : product_images
    }

    function is_array_equal(a1, a2) {
        return JSON.stringify(a1) === JSON.stringify(a2)
    }

    function find_variant_media(variant_id) {
        var variant_media;
        if (variant_id || (variant_id = find_current_variant()), variants_media.hasOwnProperty(variant_id) ? variant_media = variants_media[variant_id] : (variant_id = find_current_variant_from_url(), variant_media = variants_media.hasOwnProperty(variant_id) ? variants_media[variant_id] : variants_media[default_variant]), (!variant_media || 0 == variant_media.length) && skip_showcase_image >= product_media.length) return product_media;
        if (!is_home && "no_action" != only_run_if_variant_in_url && !is_variant_in_url()) {
            function showcase_images() {
                return variants_media.g.length ? variants_media.g : variant_assigned_media
            }

            function skipped_and_showcase_images() {
                let images = variants_media.skipped.concat(variants_media.g);
                return images.length ? images : variant_assigned_media
            }
            if (selection_vid = 0, "showcase_only" == only_run_if_variant_in_url) return showcase_images();
            if ("showcase_and_variants" == only_run_if_variant_in_url) return variants_media.g.concat(variant_assigned_media);
            if ("featured_only" == only_run_if_variant_in_url) return [product_media[0]];
            if ("featured_and_showcase" == only_run_if_variant_in_url) return skip_showcase_image > 0 ? [product_media[0]].concat(variants_media.g) : showcase_images();
            if ("skipped_and_showcase" == only_run_if_variant_in_url) return skipped_and_showcase_images();
            if ("show_all" == only_run_if_variant_in_url) return product_media
        }
        return "at_start" == general_images_position ? variant_media = variants_media.g.concat(variant_media) : "at_end" == general_images_position && (variant_media = variant_media.concat(variants_media.g)), variant_media && 0 != variant_media.length ? priority_video ? moveVideoToFront(variant_media) : variant_media : product_media
    }

    function moveVideoToFront(arr) {
        const videoIndex = arr.findIndex((obj => "video" === obj.media_type || "external_video" === obj.media_type));
        if (videoIndex > -1) {
            const videoObj = arr.splice(videoIndex, 1)[0];
            arr.unshift(videoObj)
        }
        return arr
    }
    var quick_view_enabled = false,
        skip_showcase_image = 0,
        selected_theme_name = "Impulse",
        priority_video = false,
        can_execute_script = false,
        is_home = false,
        only_run_if_variant_in_url = "no_action",
        limit_on_product = "none",
        product_url = "",
        is_product_preview = window.location.href.toLowerCase().indexOf("/products_preview") >= 0,
        is_product_page = /\/products\/|\/produkty\/|\/produkte\//.test(window.location.href.toLowerCase()),
        is_pages = (is_home = "/" == window.location.pathname, window.location.pathname.indexOf("/pages/") >= 0),
        variant_id = 0,
        selection_vid = 0,
        last_variant_images = {};
    if ((is_home || is_pages || is_product_page || is_product_preview) && (can_execute_script = !0), quick_view_enabled) var jTimer = setInterval((function() {
        window.$ && window.jQuery && (clearInterval(jTimer), $(".modal .product__thumbs").css({
            visibility: "hidden"
        }))
    }), 10);
    if (can_execute_script) {
        if (is_home) {
            product_url = product_url.replace(/\/$/, "").split("?")[0].split("#")[0]
        } else is_pages ? ("Broadcast" == selected_theme_name && (product_url = document.querySelector('[data-section-type="product"] .product__title a') ? document.querySelector('[data-section-type="product"] .product__title a').href : ""), product_url = product_url.replace(/\/$/, "").split("?")[0].split("#")[0]) : product_url = window.location.pathname.replace(/\/$/, "").replace("//", "/");
        if (product_url.length && (void 0 === window.via_product_handle || window.via_product_handle != product_url)) {
            var productJson;
            window.via_product_handle = product_url;
            var variants = {},
                product_variants = {};
            variants.g = [], variants.skipped = [];
            var product_images = [],
                default_variant = 0,
                general_images_position = "at_end",
                hide_single_thumb = false,
                variant_assigned_images = [],
                variants_media = {},
                product_media = [];
            variants_media.g = [], variants_media.skipped = [];
            var variant_assigned_media = [],
                product_tags = "",
                variant_assigned_images_ids = [],
                variant_assigned_media_ids = [],
                all_variant_media = [],
                all_variant_images = [];

            function assign_variants_media(productJson) {
                product_media = productJson.media, productJson.variants.forEach((function(variant) {
                    variant.featured_image && -1 == variant_assigned_images_ids.indexOf(variant.featured_image.id) && (variant_assigned_images_ids.push(variant.featured_image.id), variant_assigned_images.push(variant.featured_image)), variant.featured_media && -1 == variant_assigned_media_ids.indexOf(variant.featured_media.id) && (variant_assigned_media_ids.push(variant.featured_media.id), variant_assigned_media.push(variant.featured_media)), !default_variant && variant.available && (default_variant = variant.id), variant.featured_media && (all_variant_media[variant.featured_media.id] || (all_variant_media[variant.featured_media.id] = []), all_variant_media[variant.featured_media.id].push(variant.id)), variants_media[variant.id] = [], variant.featured_image && (all_variant_images[variant.featured_image.id] || (all_variant_images[variant.featured_image.id] = []), all_variant_images[variant.featured_image.id].push(variant.id)), variants[variant.id] = [], product_variants[variant.id] = variant
                }));
                var general_media = true,
                    current_variant_ids = [];
                product_media.forEach((function(media, index) {
                    general_media && -1 == variant_assigned_media_ids.indexOf(media.id) ? skip_showcase_image > 0 && index < skip_showcase_image ? variants_media.skipped.push(media) : variants_media.g.push(media) : (general_media = !1, (current_variant_ids = all_variant_media[media.id] ? all_variant_media[media.id] : current_variant_ids).forEach((function(variant_id) {
                        variants_media[variant_id].push(media)
                    })))
                }))
            }

            function assign_variant_images(images) {
                var general_images = true,
                    current_variant_ids = [];
                (product_images = images).forEach((function(image, index) {
                    general_images && -1 == variant_assigned_images_ids.indexOf(image.id) ? skip_showcase_image > 0 && index < skip_showcase_image ? variants.skipped.push(image) : variants.g.push(image) : (general_images = !1, (current_variant_ids = all_variant_images[image.id] ? all_variant_images[image.id] : current_variant_ids).forEach((function(variant_id) {
                        variants[variant_id].push(image)
                    })))
                }))
            }

            function is_restrictable() {
                return "include_selected" == limit_on_product && 0 == /via_enabled|viaenabled|via-enabled|__via_enabled/.test(product_tags.toLowerCase()) || "exclude_selected" == limit_on_product && 1 == /via_disabled|via-disabled|viadisabled|__via_disabled/.test(product_tags.toLowerCase())
            }

            function get_ready_with_data(_callback) {
                var DONE = 4,
                    OK = 200,
                    xhr_for_js = new XMLHttpRequest;
                return xhr_for_js.open("GET", product_url + ".js", !0), xhr_for_js.send(), xhr_for_js.onreadystatechange = function() {
                    if (xhr_for_js.readyState === DONE && xhr_for_js.status === OK) {
                        if (productJson = JSON.parse(xhr_for_js.responseText), product_tags = productJson.tags.join(), (void 0 === productJson.media || 0 == productJson.media.length) && 0 == productJson.images.length) return;
                        assign_variants_media(productJson);
                        var xhr_for_json = new XMLHttpRequest;
                        xhr_for_json.open("GET", product_url + ".json", !0), xhr_for_json.send(), xhr_for_json.onreadystatechange = function() {
                            xhr_for_json.readyState === DONE && (xhr_for_json.status === OK && (assign_variant_images(JSON.parse(xhr_for_json.responseText).product.images), _callback()))
                        }
                    }
                }, !0
            }

            function processJSONInformation() {
                product_tags = productJson.tags.join(), assign_variants_media(productJson), assign_variant_images(productJson.product_images), execute_app_code()
            }

            function run() {
                if (is_product_preview) try {
                    productJson = JSON.parse(document.querySelector("[sa-product-json]").innerText), processJSONInformation()
                } catch (e) {
                    setTimeout((function() {
                        run()
                    }), 100)
                } else if (document.querySelector("[sa-product-json]")) try {
                    (productJson = JSON.parse(document.querySelector("[sa-product-json]").innerText)).media && processJSONInformation()
                } catch (e) {}
                is_product_preview || productJson && productJson.media || get_ready_with_data(execute_app_code)
            }

            function execute_app_code() {
                if (!(is_restrictable() || 1 == product_media.length && 1 == product_images.length)) var nTimer = setInterval((function() {
                    if ("interactive" == document.readyState || "complete" == document.readyState) {
                        clearInterval(nTimer);
                        var cavalier_store = !1,
                            new_version = document.querySelector(".product__thumbs--scroller"),
                            section = document.querySelector('[data-section-type="product"]') ? document.querySelector('[data-section-type="product"]') : document.querySelector('[data-section-type="product-template"]'),
                            section_id = section.getAttribute("data-section-id"),
                            main_image_height = 0;
                        if (new_version) {
                            create_element_append_to_body("div", "multi-variant-info"), create_element_append_to_body("div", "multi-variant-thumb"), create_element_append_to_body("div", "multi-variant-desktop"), product_media.forEach(((image, index) => {
                                section.querySelectorAll(".product-slideshow .product-main-slide")[index].setAttribute("data-id", image.id)
                            })), document.getElementById("multi-variant-info").innerHTML = section.querySelector(".product-slideshow").innerHTML, document.getElementById("multi-variant-thumb").innerHTML = section.querySelector(".product__thumbs--scroller").innerHTML, document.querySelectorAll("#multi-variant-info img.lazyloading").forEach((image => {
                                image.classList.remove("lazyloading"), image.classList.add("lazyload")
                            })), document.querySelectorAll("#multi-variant-thumb img.lazyloading").forEach((image => {
                                image.classList.remove("lazyloading"), image.classList.add("lazyload")
                            })), document.getElementById("multi-variant-desktop").innerHTML = section.querySelector(".product-images-desktop") ? section.querySelector(".product-images-desktop").innerHTML : "", document.querySelectorAll("#multi-variant-desktop img.lazyloading").forEach((image => {
                                image.classList.remove("lazyloading"), image.classList.add("lazyload")
                            }));
                            var zTimer = setInterval((function() {
                                if ("object" == typeof theme && "function" == typeof theme.Slideshow) {
                                    clearInterval(zTimer), section.off("variantImageChange.product-" + section_id), main_image_height = section.querySelector("[data-product-single-media-group]").offsetHeight;
                                    var selectors = document.querySelectorAll('select, .panda-swatch, .single-option-selector, label, .swatches, .swatches .swatch-selector, .product-single__form, .variant-wrapper .variant-input, form[action="/cart/add"]');

                                    function variant_change_event() {
                                        setTimeout((function() {
                                            variant_id = find_current_variant(), selection_vid != variant_id && (impulse2_change_images(variant_id), selection_vid = variant_id)
                                        }), 100)
                                    }
                                    selectors && Object.entries(selectors).forEach((([index, selector]) => {
                                        selector.addEventListener("click", variant_change_event, false), selector.addEventListener("change", variant_change_event, false)
                                    })), impulse2_change_images()
                                }
                            }), 20)
                        } else {
                            section = $('[data-section-type="product-template"]:visible').length ? $('[data-section-type="product-template"]:visible') : $('[data-section-type="product"]'), section = $('[data-section-id="' + productJson.id + '"]').length ? $('[data-section-id="' + productJson.id + '"]') : section, section_id = section.attr("data-section-id");
                            var media_used, all_images = (media_used = $("[data-product-single-media-group]").length > 0) ? product_media : product_images;
                            $("#ProductPhotos-" + section_id + " div[data-index]:not(.slick-cloned)", section).each((function(index, obj) {
                                $(obj).attr("data-image-id", all_images[index].id), $("#ProductThumbs-" + section_id + " div[data-index]:not(.slick-cloned)", section).eq(index).attr("data-image-id", all_images[index].id)
                            })), 0 == $("#multi-variant-info-" + productJson.id).length && ($("body").append("<div id='multi-variant-info-" + productJson.id + "' style='display:none'></div>"), $("body").append("<div id='multi-variant-thumb-" + productJson.id + "' style='display:none'></div>"), $("#multi-variant-info-" + productJson.id).html($("#ProductPhotos-" + section_id, section).html()), $("#multi-variant-thumb-" + productJson.id).html($("#ProductThumbs-" + section_id, section).html()), $("#multi-variant-info-" + productJson.id + " img.lazyloading").removeClass("lazyloading").addClass("lazyload"), $("#multi-variant-thumb-" + productJson.id + " img.lazyloading").removeClass("lazyloading").addClass("lazyload"), $("body").append("<div id='multi-variant-desktop' style='display:none'></div>"), $("#multi-variant-desktop").html($(".hc-photos.hc-desktop").html()), !0), section.off("variantImageChange.product-" + section_id), section.off("variantImageChange");
                            var videos = [],
                                youtubePlayers = [],
                                youtubeVideoOptions = {
                                    height: "480",
                                    width: "850",
                                    playerVars: {
                                        autohide: 0,
                                        autoplay: 1,
                                        branding: 0,
                                        cc_load_policy: 0,
                                        controls: 0,
                                        fs: 0,
                                        iv_load_policy: 3,
                                        modestbranding: 1,
                                        playsinline: 1,
                                        quality: "hd720",
                                        rel: 0,
                                        showinfo: 0,
                                        wmode: "opaque"
                                    },
                                    events: {
                                        onReady: onVideoPlayerReady,
                                        onStateChange: onVideoStateChange
                                    }
                                };
                            zTimer = setInterval((function() {
                                "function" == typeof $.fn.slick && (clearInterval(zTimer), impulse_change_images(), $("body").on("change click", "select, label, .swatches .swatch-selector", (function() {
                                    setTimeout((function() {
                                        variant_id = find_current_variant(section[0]), selection_vid != variant_id && (impulse_change_images(variant_id), selection_vid = variant_id)
                                    }), 100)
                                })))
                            }), 10)
                        }

                        function impulse_change_images(variant_id) {
                            if (variant_images = media_used ? find_variant_media(variant_id) : find_variant_images(variant_id), is_array_equal(last_variant_images, variant_images)) return;
                            last_variant_images = variant_images;
                            var slide_images = "",
                                thumb_images = "",
                                desktop_images = "";
                            $.each(variant_images, (function(index, image) {
                                var obj = $("#multi-variant-info-" + productJson.id + " div[data-image-id='" + image.id + "']").clone();
                                if (obj.length) {
                                    if (obj.find(".photoswipe__image").length && obj.find(".photoswipe__image").attr("data-index", index + 1), obj.find("[data-video-type]").length)
                                        if ("youtube" == obj.find("[data-video-type]").data("video-type")) {
                                            var vid = obj.find(".product__video");
                                            if (vid.length) {
                                                var wrapper = '<div id="' + vid.attr("id") + '" class="product__video" data-video-type="youtube" data-video-style="muted" data-video-loop="true" data-youtube-id="' + vid.attr("data-youtube-id") + '"></div>';
                                                obj.find("[data-video-type]").html(wrapper)
                                            }
                                        } else obj.find("[data-video-type]").html(obj.find(".product__video").removeAttr("id").attr("id", image.id).clone().wrap("<div></div>").parent().html());
                                    slide_images += obj.attr("data-index", index).removeAttr("style").wrap("<div></div>").parent().html(), thumb_images += $("#multi-variant-thumb-" + productJson.id + " div[data-image-id='" + image.id + "']").clone().attr("data-index", index).removeAttr("style").wrap("<div></div>").parent().html(), desktop_images += $("#multi-variant-desktop .hc-image[data-image-id='" + image.id + "']").clone().removeAttr("style").wrap("<div></div>").parent().html()
                                }
                            }));
                            try {
                                $("#ProductPhotos-" + section_id, section).slick("unslick"), $("#ProductThumbs-" + section_id, section).slick("unslick")
                            } catch (e) {}
                            $("#ProductPhotos-" + section_id, section).html(slide_images), $("#ProductThumbs-" + section_id, section).html(thumb_images), $(".hc-photos.hc-desktop").html(desktop_images), videos = [];
                            var $videos = $("#ProductPhotos-" + section_id + " .product__video", section);
                            loadYoutubeVideos($videos), loadMp4Videos($videos);
                            var is_bpSmall = $(window).width() < 769;
                            1 == variant_images.length && hide_single_thumb ? $("#ProductThumbs-" + section_id, section).hide() : $("#ProductThumbs-" + section_id, section).show();
                            var args = {},
                                desktopInfinite = false,
                                fadeEffect = true,
                                slidesToShow = 1,
                                maverick_store = false;
                            var mainSliderArgs = {
                                    infinite: true,
                                    arrows: false,
                                    dots: true,
                                    adaptiveHeight: true,
                                    initialSlide: 0,
                                    rtl: "object" == typeof theme && theme.config && theme.config.rtl
                                },
                                thumbSliderArgs = {
                                    initialSlide: 0
                                };
                            $(".product__photo-dots", section).length && (mainSliderArgs = $.extend({}, mainSliderArgs, {
                                appendDots: $(".product__photo-dots", section)
                            }));
                            var thumbnailsVertical = "beside" === $("#ProductThumbs-" + section_id, section).data("position"),
                                thumbArrows = $("#ProductThumbs-" + section_id, section).data("arrows") || false,
                                slidesToShowThumb = thumbnailsVertical ? 3 : 5;
                            is_bpSmall ? (args.main = mainSliderArgs, args.thumbs = thumbSliderArgs) : (args.main = $.extend({}, mainSliderArgs, {
                                asNavFor: "#ProductThumbs-" + section_id,
                                adaptiveHeight: !thumbnailsVertical,
                                dots: false,
                                slidesToShow: slidesToShow,
                                infinite: desktopInfinite,
                                fade: fadeEffect
                            }), args.thumbs = $.extend({}, thumbSliderArgs, {
                                asNavFor: "#ProductPhotos-" + section_id,
                                slidesToShow: slidesToShowThumb,
                                slidesToScroll: 1,
                                arrows: thumbArrows,
                                dots: false,
                                vertical: thumbnailsVertical,
                                verticalSwiping: thumbnailsVertical,
                                focusOnSelect: true,
                                infinite: false,
                                customHeightMatching: thumbnailsVertical,
                                customSlideAdvancement: trueq
                            })), $("#ProductPhotos-" + section_id, section).css("visibility", "visible"), $("#ProductThumbs-" + section_id, section).css("visibility", "visible"), section.addClass("starapps"), (!cavalier_store || cavalier_store && is_bpSmall) && $("#ProductPhotos-" + section_id, section).slick(args.main), is_bpSmall && !maverick_store || $("#ProductThumbs-" + section_id, section).not(".slick-initialized").slick(args.thumbs), $("[data-product-thumb], .product__thumb-" + section_id).off("click").on("click", (function(evt) {
                                evt.preventDefault()
                            })), $("#ProductSection-" + section_id).data("image-zoom") && (initializeZoom($("#ProductPhotos-" + section_id + " .photo-zoom-link:first img", section)), $("#ProductPhotos-" + section_id + " .photo-zoom-link img", section).each((function(index, obj) {
                                initializeZoom($(obj))
                            }))), initPhotoswipeZoom();
                            try {
                                theme.videoModal()
                            } catch (e) {}
                            document.dispatchEvent(new CustomEvent("starapps:variant:change"))
                        }

                        function initializeZoom($image) {
                            if ("function" == typeof $.fn.zoom) {
                                var largeImage = $image.parent().data("zoom-size");
                                $image.parent().on("click", (function(evt) {
                                    evt.preventDefault()
                                })).zoom({
                                    on: "click",
                                    url: largeImage,
                                    duration: 180,
                                    touch: false,
                                    onZoomIn: function() {
                                        $(this).addClass("photo-zoom-linked")
                                    },
                                    onZoomOut: function() {
                                        $(this).removeClass("photo-zoom-linked")
                                    }
                                })
                            }
                        }

                        function initPhotoswipeZoom() {
                            theme && "function" == typeof theme.Photoswipe && new Photoswipe("[data-product-images]", section_id)
                        }
                        if (!new_version) var Photoswipe = function() {
                            function Photoswipe(container, sectionId) {
                                this.$container = $(container), this.sectionId = sectionId, this.namespace = ".photoswipe-" + this.sectionId, this.gallery, this.$images, this.inSlideshow = !1, "false" !== this.$container.attr("data-zoom") && ("true" === this.$container.attr("data-has-slideshow") && (this.inSlideshow = !0), this.init())
                            }
                            var selectors = {
                                trigger: ".js-photoswipe__zoom",
                                images: "div[data-index]:not(.slick-cloned) .photoswipe__image",
                                activeImage: ".slick-active .photoswipe__image"
                            };
                            return Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
                                init: function() {
                                    var $trigger = this.$container.find(selectors.trigger);
                                    this.$images = this.$container.find(selectors.images);
                                    var items = [];
                                    $trigger.off("click" + this.namespace).on("click" + this.namespace, function(evt) {
                                        if (items = this.getImageData(), this.inSlideshow) var index = this.$container.find(selectors.activeImage).data("index");
                                        else index = $(evt.currentTarget).data("index");
                                        this.initGallery(items, index)
                                    }.bind(this))
                                },
                                getImageData: function() {
                                    var items = [];
                                    return this.$images.each((function() {
                                        var item = {
                                            msrc: $(this).prop("currentSrc") || $(this).prop("src"),
                                            src: $(this).data("photoswipe-src"),
                                            w: $(this).data("photoswipe-width"),
                                            h: $(this).data("photoswipe-height"),
                                            el: $(this)[0],
                                            initialZoomLevel: .5
                                        };
                                        items.push(item)
                                    })), items
                                },
                                initGallery: function(items, index) {
                                    $(".pswp, [data-photoswipe2]").remove();
                                    var html = '<div class="pswp" data-photoswipe2 tabindex="-1" role="dialog" aria-hidden="true"> <div class="pswp__bg"></div><div class="pswp__scroll-wrap"> <div class="pswp__container"> <div class="pswp__item"></div><div class="pswp__item"></div><div class="pswp__item"></div></div><div class="pswp__ui pswp__ui--hidden"> <button class="btn btn--no-animate btn--body btn--circle pswp__button pswp__button--arrow--left" title="Previous"> <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"/></svg> </button> <button class="btn btn--no-animate btn--body btn--circle btn--large pswp__button pswp__button--close" title="Close (esc)"> <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg> </button> <button class="btn btn--no-animate btn--body btn--circle pswp__button pswp__button--arrow--right" title="Next"> <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"/></svg> </button> </div></div></div>';
                                    $("body").append(html);
                                    var pswpElement = document.querySelector("[data-photoswipe2]"),
                                        options = {
                                            allowPanToNext: false,
                                            captionEl: false,
                                            closeOnScroll: false,
                                            counterEl: false,
                                            history: false,
                                            index: index - 1,
                                            pinchToClose: false,
                                            preloaderEl: false,
                                            scaleMode: "zoom",
                                            shareEl: false,
                                            tapToToggleControls: false,
                                            getThumbBoundsFn: function(index) {
                                                var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                                                    rect = items[index].el.getBoundingClientRect();
                                                return {
                                                    x: rect.left,
                                                    y: rect.top + pageYScroll,
                                                    w: rect.width
                                                }
                                            }
                                        };
                                    this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options), this.gallery.init(), this.gallery.listen("afterChange", this.afterChange.bind(this)), this.gallery.listen("destroy", (function() {
                                        $(".pswp, [data-photoswipe2]").remove()
                                    }))
                                },
                                afterChange: function() {
                                    if (this.inSlideshow) {
                                        var $slideshow = $("#ProductPhotos-" + this.sectionId);
                                        if ($slideshow.hasClass("slick-initialized")) {
                                            var newIndex = this.gallery.getCurrentIndex();
                                            $slideshow.slick("slickGoTo", newIndex)
                                        }
                                    }
                                }
                            }), Photoswipe
                        }();

                        function impulse2_change_images(variant_id) {
                            function initModelViewerLibraries() {
                                var modelViewerElements = container.querySelectorAll(selectors.media);
                                modelViewerElements.length < 1 || theme.ProductMedia.init(modelViewerElements, sectionId)
                            }

                            function initProductSlider() {
                                var mainSliderArgs = {
                                    dragThreshold: 25,
                                    adaptiveHeight: true,
                                    avoidReflow: true,
                                    initialIndex: settings.currentSlideIndex,
                                    childNav: cache.thumbSlider,
                                    childNavScroller: cache.thumbScroller,
                                    childVertical: "beside" === cache.thumbSlider.dataset.position,
                                    pageDots: true,
                                    wrapAround: false,
                                    callbacks: {
                                        onChange: onSlideChange.bind(this)
                                    }
                                };
                                flickity = new theme.Slideshow(cache.mainSlider, mainSliderArgs), setTimeout((function() {
                                    container.querySelector(".product__thumb-arrow.product__thumb-arrow--prev") && container.querySelector(".product__thumb-arrow.product__thumb-arrow--prev").classList.add("hide"), mainSliderArgs.childVertical ? cache.thumbScroller.scrollTop = 0 : cache.thumbScroller.scrollLeft = 0
                                }), 100)
                            }

                            function onSlideChange(index) {
                                if (flickity) {
                                    var allSlides = cache.mainSlider.querySelectorAll(selectors.slide),
                                        prevSlide = allSlides[settings.currentSlideIndex],
                                        nextSlide = allSlides[index];
                                    prevSlide.setAttribute("tabindex", "-1"), nextSlide.setAttribute("tabindex", 0), stopMediaOnSlide(prevSlide), prepMediaOnSlide(nextSlide), settings.currentSlideIndex = index
                                }
                            }

                            function stopMediaOnSlide(slide) {
                                var video = slide.querySelector(selectors.productVideo);
                                if (video) {
                                    var videoType = _getVideoType(video),
                                        videoId = _getVideoDivId(video);
                                    if ("youtube" === videoType) {
                                        if (videoObjects[videoId].videoPlayer) return void videoObjects[videoId].videoPlayer.stopVideo()
                                    } else if ("mp4" === videoType) return void stopMp4Video(videoId)
                                }
                                var currentMedia = slide.querySelector(selectors.media);
                                currentMedia && currentMedia.dispatchEvent(new CustomEvent("mediaHidden", {
                                    bubbles: true,
                                    cancelable: true
                                }))
                            }

                            // For Left arrow
                            function prepMediaOnSlide(slide) {
                                var video = slide.querySelector(selectors.productVideo);
                                if (video) {
                                    var videoType = _getVideoType(video),
                                        videoId = _getVideoDivId(video);
                                    "youtube" === videoType ? videoObjects[videoId].videoPlayer && "sound" !== videoObjects[videoId].options.style && ("function" == typeof videoObjects[videoId].videoPlayer.playVideo ? videoObjects[videoId].videoPlayer.playVideo() : slide.querySelector(".product__video-wrapper.loading") && setTimeout((function() {
                                        slide.querySelector(".product__video-wrapper.loading")?.classList.remove("loading")
                                    }), 500)) : "mp4" === videoType && playMp4Video(videoId)
                                }
                                var nextMedia = slide.querySelector(selectors.media);
                                nextMedia && (nextMedia.dispatchEvent(new CustomEvent("mediaVisible", {
                                    bubbles: true,
                                    cancelable: true
                                })), slide.querySelector(".shopify-model-viewer-ui__button")?.setAttribute("tabindex", 0), slide.querySelector(".product-single__close-media")?.setAttribute("tabindex", 0))
                            }

                            function videoSetup() {
                                var productVideos = cache.mainSlider.querySelectorAll(selectors.productVideo);
                                if (!productVideos.length) return false;
                                productVideos.forEach((vid => {
                                    var type = vid.dataset.videoType;
                                    "youtube" === type ? initYoutubeVideo(vid) : "mp4" === type && initMp4Video(vid)
                                }))
                            }

                            function initYoutubeVideo(div) {
                                videoObjects[div.id] = new theme.YouTube(div.id, {
                                    videoId: div.dataset.youtubeId,
                                    videoParent: selectors.videoParent,
                                    autoplay: !1,
                                    style: div.dataset.videoStyle,
                                    loop: div.dataset.videoLoop,
                                    events: {
                                        onReady: youtubePlayerReady.bind(this),
                                        onStateChange: youtubePlayerStateChange.bind(this)
                                    }
                                })
                            }

                            function youtubePlayerReady(evt) {
                                var iframeId = evt.target.getIframe().id;
                                if (videoObjects[iframeId]) {
                                    var obj = videoObjects[iframeId],
                                        player = obj.videoPlayer;
                                    "sound" !== obj.options.style && player.mute(), obj.parent.classList.remove("loading"), obj.parent.classList.add("loaded"),
                                    _isFirstSlide(iframeId) && "sound" !== obj.options.style && player.playVideo()
                                }
                            }

                            function _isFirstSlide(id) {
                                return cache.mainSlider.querySelector(selectors.startingSlide + " #" + id)
                            }

                            function youtubePlayerStateChange(evt) {
                                var iframeId = evt.target.getIframe().id,
                                    obj = videoObjects[iframeId];
                                switch (evt.data) {
                                    case -1:
                                        obj.attemptedToPlay && obj.parent.classList.add("video-interactable");
                                        break;
                                    case 0:
                                        obj && "true" === obj.options.loop && obj.videoPlayer.playVideo();
                                        break;
                                    case 3:
                                        obj.attemptedToPlay = !0
                                }
                            }

                            function initMp4Video(div) {
                                videoObjects[div.id] = {
                                    id: div.id,
                                    type: "mp4"
                                }, _isFirstSlide(div.id) && playMp4Video(div.id)
                            }

                            function _getVideoType(video) {
                                return video.getAttribute("data-video-type")
                            }

                            function _getVideoDivId(video) {
                                return video.id
                            }

                            function playMp4Video(id) {
                                var player = container.querySelector("#" + id),
                                    playPromise = player.play();
                                void 0 !== playPromise && playPromise.then((function() {})).catch((function() {
                                    player.setAttribute("controls", ""), player.closest(selectors.videoParent).setAttribute("data-video-style", "unmuted")
                                }))
                            }

                            function stopMp4Video(id) {
                                var player = container.querySelector("#" + id);
                                player && "function" == typeof player.pause && player.pause()
                            }

                            function initImageZoom() {
                                var container = section.querySelector(selectors.imageContainer);
                                if (container) {
                                    new theme.Photoswipe(container, sectionId);
                                    container.addEventListener("photoswipe:afterChange", function(evt) {
                                        flickity && flickity.goToSlide(evt.detail.index)
                                    }.bind(this))
                                }
                            }

                            function customMediaListners() {
                                container.querySelectorAll(selectors.closeMedia).forEach((el => {
                                    el.addEventListener("click", function() {
                                        var media = mainSlider.querySelector(selectors.currentSlide).querySelector(selectors.media);
                                        media && media.dispatchEvent(new CustomEvent("mediaHidden", {
                                            bubbles: true,
                                            cancelable: true
                                        }))
                                    }.bind(this))
                                }));
                                var modelViewers = container.querySelectorAll("model-viewer");
                                modelViewers.length && modelViewers.forEach((el => {
                                    el.addEventListener("shopify_model_viewer_ui_toggle_play", function(evt) {
                                        mediaLoaded(evt)
                                    }.bind(this)), el.addEventListener("shopify_model_viewer_ui_toggle_pause", function(evt) {
                                        mediaUnloaded(evt)
                                    }.bind(this))
                                }))
                            }

                            function mediaLoaded() {
                                container.querySelectorAll(selectors.closeMedia).forEach((el => {
                                    el.classList.remove(classes.hidden)
                                })), flickity && flickity.setDraggable(false)
                            }

                            function mediaUnloaded() {
                                container.querySelectorAll(selectors.closeMedia).forEach((el => {
                                    el.classList.add(classes.hidden)
                                })), flickity && flickity.setDraggable(true)
                            }
                            if (variant_images = find_variant_media(variant_id), !is_array_equal(last_variant_images, variant_images)) {
                                last_variant_images = variant_images, main_image_height && (section.querySelector("[data-product-single-media-group]").style.minHeight = main_image_height + "px", section.querySelector("[data-product-single-media-group]").style.visibility = "hidden");
                                var slide_images = "",
                                    thumb_images = "";
                                variant_images.forEach(((image, index) => {
                                    let main = document.querySelector("#multi-variant-info .product-main-slide[data-id='" + image.id + "']");
                                    main.setAttribute("data-index", index), main.querySelector(".photoswipe__image")?.setAttribute("data-index", index + 1), main.removeAttribute("style"), "model" == image.media_type && (main.querySelector("[data-product-media-type-model]").innerHTML = main.querySelector("model-viewer").outerHTML), slide_images += main.outerHTML;
                                    let thumb = document.querySelector("#multi-variant-thumb a[data-id='" + image.id + "']");
                                    thumb && (thumb.setAttribute("data-index", index), thumb = thumb.closest(".product__thumb-item"), thumb.setAttribute("data-index", index), thumb.classList.remove("hide"), thumb_images += thumb.outerHTML)
                                })), Flickity.data(".product-slideshow") && Flickity.data(".product-slideshow").destroy(), section.querySelector(".product-slideshow").innerHTML = slide_images, section.querySelector(".product__thumbs--scroller").innerHTML = thumb_images, 1 == variant_images.length && hide_single_thumb ? section.querySelector(".product__thumbs").style.display = "none" : section.querySelector(".product__thumbs").style.display = "";
                                var container = section,
                                    sectionId = container.getAttribute("data-section-id"),
                                    inModal = "true" === container.dataset.modal,
                                    classes = {
                                        onSale: "on-sale",
                                        disabled: "disabled",
                                        isModal: "is-modal",
                                        loading: "loading",
                                        loaded: "loaded",
                                        hidden: "hide",
                                        interactable: "video-interactable",
                                        visuallyHide: "visually-invisible"
                                    },
                                    settings = {
                                        enableHistoryState: container.dataset.history || false,
                                        namespace: ".product-" + sectionId,
                                        inventory: container.dataset.inventory || false,
                                        incomingInventory: container.dataset.incomingInventory || false,
                                        modalInit: false,
                                        hasImages: true,
                                        imageSetName: null,
                                        imageSetIndex: null,
                                        currentImageSet: null,
                                        imageSize: "620x",
                                        currentSlideIndex: 0,
                                        videoLooping: container.dataset.videoLooping
                                    };
                                inModal && (settings.enableHistoryState = false, settings.namespace = ".product-" + sectionId + "-modal", document.getElementById("QuickShopModal-" + sectionId));
                                var flickity, selectors = {
                                        media: "[data-product-media-type-model]",
                                        closeMedia: ".product-single__close-media",
                                        photoThumbs: ".product__thumb-" + sectionId,
                                        thumbSlider: "#ProductThumbs-" + sectionId,
                                        photoThumbs2: "[data-product-thumb]",
                                        thumbSlider2: "[data-product-thumbs]",
                                        thumbScroller: ".product__thumbs--scroller",
                                        mainSlider: "#ProductPhotos-" + sectionId,
                                        mainSlider2: "[data-product-photos]",
                                        imageContainer: "[data-product-images]",
                                        productImageMain: ".product-image-main--" + sectionId,
                                        productVideo: ".product__video",
                                        videoParent: ".product__video-wrapper",
                                        slide: ".product-main-slide",
                                        currentSlide: ".is-selected",
                                        startingSlide: ".starting-slide"
                                    },
                                    cache = {
                                        mainSlider: container.querySelector(selectors.mainSlider) ? container.querySelector(selectors.mainSlider) : container.querySelector(selectors.mainSlider2),
                                        thumbSlider: container.querySelector(selectors.thumbSlider) ? container.querySelector(selectors.thumbSlider) : container.querySelector(selectors.thumbSlider2),
                                        thumbScroller: container.querySelector(selectors.thumbScroller),
                                        productImageMain: container.querySelector(selectors.productImageMain)
                                    },
                                    videoObjects = {};
                                videoSetup(), initProductSlider(), initImageZoom(), initModelViewerLibraries(), customMediaListners(), "function" == typeof theme.videoModal && theme.videoModal(), section.querySelector("[data-product-single-media-group]").style.minHeight = "auto", section.querySelector("[data-product-single-media-group]").style.visibility = "", main_image_height || (main_image_height = section.querySelector("[data-product-single-media-group]").clientHeight)
                            }
                        }
                    }
                }), 10)
            }
            run()
        }
    }
};
snappervariantImageFilter();